import config from '@config'

export const TOGGLE_SIGNAL_DETAIL = 'TOGGLE_SIGNAL_DETAIL'
export const TOGGLE_SIGNAL_FLAG = 'TOGGLE_SIGNAL_FLAG'

export const SIGNALS_WITH_HIDDEN_ENTITY = ['RECV', 'D0TR']
export const SIGNALS_WITH_TOGGABLE_FLAG = ['D0TR']

export const NON_PUBLICATION_FINANCIAL_STATEMENTS = 'FV07'

// Specifies which signal icons should be clickable
export const SIGNAL_SCROLL_REFS_MAP = {
    // Shoda adresy s úřadem
    AD01: config.modules.report.blocks.addresses.key,
    // Rizikové subjekty na adrese
    AD03: config.modules.report.blocks.addresses.key,
    // Nízká běžná likvidita
    FV04: config.modules.report.blocks.fanal.key,
    // Vysoká zadluženost SK
    FV01: config.modules.report.blocks.fanal.key,
    // Vysoká zadluženost CZ
    FV02: config.modules.report.blocks.fanal.key,
    // Firma ve ztrátě
    FV05: config.modules.report.blocks.fstmt.key,
    // Záporný VK
    FV03: config.modules.report.blocks.fstmt.key,
    // Výkon zástavního práva v registru zástavních práv (SK)
    D006: config.modules.report.blocks.liens.key,
    // Zástavní právo v registru zástavních práv (SK)
    D005: config.modules.report.blocks.liens.key,
    // Zástavní právo na podíl vlastníka
    RE01: config.modules.report.blocks.liens.key,
    // Zástavní právo na podíl vlastníka
    RE05: config.modules.report.blocks.liens.key,
    // Povinnost publikovat smlouvy
    RE04: config.modules.report.blocks.contracts.key,
    // Virtuální sídlo
    AD05: config.modules.report.blocks.addresses.key,
}

export const VIRTUAL_HEADQUOTERS = ['AD05']
export const CIA_NEWS_CODE = 'D0CN'

export const SIGNALS_OPEN_CIA_NEWS = 'SIGNALS_OPEN_CIA_NEWS'
export const SIGNALS_CIA_NEWS_REQUEST = 'SIGNALS_CIA_NEWS_REQUEST'
export const SIGNALS_SET_CIA_NEWS_BTN_DISABLED = 'SIGNALS_SET_CIA_NEWS_BTN_DISABLED'

export const SET_IS_SCROLLED = 'SET_IS_SCROLLED'
